import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import '@cortex/web-api/styles/tokens.css';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found in index.html');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
